module.exports = __webpack_public_path__ + "img/go-home.6650f045.png";